<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'

const props = defineProps<{
  name: string
  class?: string
}>()

// Default size - applied when no size class is provided
const defaultSize = 'w-4 h-4'

// Check if a size class is provided in the class prop
const hasCustomSize = computed(() => {
  if (!props.class) return false
  return /\b(w-|h-|size-)/.test(props.class)
})

// Combine default size with custom classes
const computedClass = computed(() => {
  if (hasCustomSize.value) {
    return props.class
  }
  return props.class ? `${defaultSize} ${props.class}` : defaultSize
})

// Auto-import all SVG icons from assets/icons folder
const iconModules = import.meta.glob('@/assets/icons/*.svg')

// Get the icon component based on the name prop
// Support both 'ralph:iconname' and 'iconname' formats
const iconName = computed(() => {
  return props.name.replace('ralph:', '')
})

const IconComponent = computed(() => {
  const path = `/assets/icons/${iconName.value}.svg`
  const loader = iconModules[path]
  if (loader) {
    return defineAsyncComponent(loader as () => Promise<any>)
  }
  return null
})
</script>

<template>
  <component 
    :is="IconComponent" 
    v-if="IconComponent" 
    :class="computedClass"
  />
  <span v-else class="text-red-500" :title="`Icon '${name}' not found`">⚠️</span>
</template>



